import * as React from 'react';
import { sortableElement } from 'react-sortable-hoc';
import { ContextMenuTrigger } from 'react-contextmenu';

const DraggableElement = sortableElement(({ children }) => children);

const PlanningTemplateRow = ({
  index,
  collection,
  planningTemplateRow,
  setFocusedRow,
  readOnly,
  children,
  ...props
}) => {
  const draggableElement = (
    <DraggableElement
      index={index}
      collection={collection}
      disabled={readOnly}
    >
      <div {...props}>{children}</div>
    </DraggableElement>
  );

  if (readOnly) {
    return draggableElement;
  }

  return (
    <ContextMenuTrigger
      id='planning_template_context_menu'
      holdToDisplay={-1}
      collect={() => {
        setFocusedRow(planningTemplateRow);

        return planningTemplateRow;
      }}
    >
      {draggableElement}
    </ContextMenuTrigger>
  );
};

export default PlanningTemplateRow;
